export const START_LOGIN = "auth/START_LOGIN";
export const LOGIN_FAIL = "auth/LOGIN_FAIL";
export const LOGIN_SUCCESS = "auth/LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "auth/LOGOUT_SUCCESS";
export const CREATION_SUCCESS = "auth/CREATION_SUCCESS";
export const START_CREATION = "auth/START_CREATION";
export const CREATION_FAIL = "auth/CREATION_FAIL";
export const CHANGING_PASSWORD = "auth/CHANGING_PASSWORD";
export const CHANGING_PASSWORD_FAIL = "auth/CHANGING_PASSWORD_FAIL";
export const CHANGING_PASSWORD_SUCCESS = "auth/CHANGING_PASSWORD_SUCCESS";
export const SEND_RESET_PASSWORD_MAIL = "auth/SEND_RESET_PASSWORD_MAIL";
export const SEND_RESET_PASSWORD_MAIL_FAILED =
  "auth/SEND_RESET_PASSWORD_MAIL_FAILED";
export const SEND_RESET_PASSWORD_MAIL_SUCCESS =
  "auth/SEND_RESET_PASSWORD_MAIL_SUCCESS";
export const START_CHECK = "auth/START_CHECK";
export const CHECK_LOGIN_FAIL = "auth/CHECK_LOGIN_FAIL";
export const CHECK_LOGIN_SUCCESS = "auth/CHECK_LOGIN_SUCCESS";
export const CONFIRMATION_SUCCESS = "auth/CONFIRMATION_SUCCESS";
export const RESEND_EMAIL_CONFIRMATION = "auth/RESEND_EMAIL_CONFIRMATION";
export const CONFIRM_OTP = "auth/CONFIRM_OTP";
export const START_CONFIRM_OTP = "auth/START_CONFIRM_OTP";
export const FAILED_CONFIRM_OTP = "auth/FAILED_CONFIRM_OTP";
